module.exports = __webpack_public_path__ + "static/media/red.96dd8880.jpg";